import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

export default function Dropdown(props) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    const close = () => setActive(false);
    if (active) {
      document.addEventListener('click', close);
      return () => {
        document.removeEventListener('click', close)
      };
    }
  }, [active]);

  return (
    <div
      className={classNames('navbar-item has-dropdown', active && 'is-active')}
      onClick={() => setActive(true)}
    >
      {props.target}
      <div
        className="navbar-dropdown is-right"
        onClick={(e) => {
          e.stopPropagation();
          setActive(false);
        }}
      >
        {props.content}
      </div>
    </div>
  );
}
